import { defineStore } from 'pinia'
import api from '@/api/api'

function parseUserSafe() {
    try {
        const raw = localStorage.getItem('user')
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: parseUserSafe(),
        token: localStorage.getItem('token') || null
    }),
    actions: {
        async login(username, password) {
            const { data } = await api.post('auth/login', { username, password })
            this.token = data.token
            this.user = data.user
            localStorage.setItem('token', this.token)
            localStorage.setItem('user', JSON.stringify(this.user))
        },
        logout() {
            this.token = null
            this.user = null
            localStorage.removeItem('token')
            localStorage.removeItem('user')
        }
    }
})
